export default __webpack_public_path__ + "static/media/ETEF-12.1a078194.pdf";